const POPUP_ATTRS = ["role", "aria-haspopup", "aria-expanded", "aria-owns"];

/**
 * Moves Vuetify 2 v-select popup semantics from the input slot wrapper (role="button" around a
 * focusable input, an axe nested-interactive violation) onto the input itself, following the
 * WAI-ARIA select-only combobox pattern. Subclasses (autocomplete, combobox, overflow-btn) manage
 * their own roles and are left untouched.
 */
export function applySelectA11yPatch(VSelect) {
  const methods = VSelect.options.methods;
  const genInputSlot = methods.genInputSlot;
  const genInput = methods.genInput;
  const isPlainSelect = (vm) => vm.$options.name === "v-select";

  methods.genInputSlot = function () {
    const render = genInputSlot.call(this);
    const attrs = render?.data?.attrs;
    if (isPlainSelect(this) && attrs) {
      POPUP_ATTRS.forEach((attr) => delete attrs[attr]);
    }
    return render;
  };

  methods.genInput = function () {
    const input = genInput.call(this);
    if (isPlainSelect(this) && input?.data) {
      input.data.attrs = {
        ...input.data.attrs,
        role: "combobox",
        "aria-haspopup": "listbox",
        "aria-expanded": String(this.isMenuActive),
        "aria-controls": this.computedOwns,
      };
    }
    return input;
  };
}
